import datapointNames from './datapointNames';

const creditRiskDatapointChoices = [
  { id: datapointNames.CREDIT_RATING, name: 'Credit Rating' },
  { id: datapointNames.PROBABILITY_OF_DEFAULT, name: 'Probability Of Default' },
];

export default creditRiskDatapointChoices;
